<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'



export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <div>
            <vs-button style="width:100%;" class="btnSmall" :disabled="!bizregistration" :href="bizregistration.remote_path" target="_blank" @click="btnClickedHandler2()" >사업자등록증</vs-button> 
        </div>
    `,
  data(){
    return{
      title : '',
      bizregistration : '',
    }
  },
  created(){
    this.title = this.params.colDef.headerName
    this.bizregistration = this.params.data.bizregistration
    console.log(this.params.data)
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }
  },
});

export default {
    name: 'genreList',
  
    data () {
        return {
            genreName : null,
            genreCategory : null,
            genreCategortyOption :[
                "팝",
                "팝/재즈/연주곡",
                "랩/힙합",
                'OST',
                '일반가요/포크/발라드',
                '록/팝/포크',
                '아동',
                '기타',
                '발라드',
                '록/포크',
                '종교음악',
                '아동/기타',
                '록',
                '재즈/록',
                '뉴에이지',
                '캐롤',
                '포크',
                '일반가요',
                '일렉트로니카',
                '댄스',
                '크로스오버',
                '알앤비/소울',
                '성인가요',
                '국악',
                '월드',
                '재즈',
                '연주곡',
                '클래식',
                '일반가요'
            ],

            optionData : optionData,
            
            roleType : null,
            entity: '사업자개인',

            keywordOption :optionData.artistKeyword,
            keywordType :'display_name',
            keyword : '',
            total : 0,
            page: {
                pageSize : 100,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                context: {
                    componentParent: this
                },
                onRowClicked: (event)=>{
                    console.log('row',event.event.target.classList);
                    let classText = JSON.stringify(event.event.target.classList);
                    
                    console.log(classText);
                    if(classText.indexOf('button') < 0 ){
                        this.viewDetail(event)
                    }
                   
                },
                frameworkComponents : {
                    btnDelete : BtnDelete,
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            columnDefs: [
                
                // aggregator_ref: null
                // contract_date: null
                // created_at: "2020-09-09T09:37:11.366Z"
                // display_name: "Global Stores"
                // email: "global@soribada.com"
                // id: 19
                // name: "소리바다(해외)"
                // settlement_link: null
                // updated_at: "2020-09-09T09:37:11.366Z"
                // upload_link: null
                {headerName: 'active 여부',  field: 'active',  filter: false,width: 120,cellRenderer: (data) => {
                return data.value ? 'Y' : 'N'
                }},
                {headerName: '계약사',  field: 'name',  filter: false,width: 200},
                {headerName: '계약사(Display)파트너사',    field: 'display_name',   filter: false,width: 250},
                {headerName: 'TAX수신메일',    field: 'email',   filter: false,width: 250},
                {headerName: '담당자',    field: 'contact_name',   filter: false,width: 200},
                {headerName: '담당자 연락처',    field: 'contact_phone',   filter: false,width: 200},
                {headerName: '메모',    field: 'memo',   filter: false,width: 200},
                {headerName: '사업자등록증', field: 'bizregistration', filter: false,minWidth: 140,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.genreEdit(data.id);
                        },
                        clicked2 : function(data) {
                            
                            //this.context.componentParent.genreDelete(data.id);
                        }

                    },
                    cellRenderer: 'btnDelete'
                },
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '업데이트일',      field: 'updated_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
            ],
            columns : [
         
                {label: 'active 여부',  field: 'active',  width: 120, formatFn: (data) => {
                    let text  = data ? 'Y' : 'N'
                    return text
                }},
                
                {label: '계약사',  field: 'name', width: '200px'},
                {label: '계약사(Display)파트너사',    field: 'display_name', width: '250px'},
                {label: 'TAX수신메일',    field: 'email',   filter: false,width: 250},
                {label: '담당자',    field: 'contact_name',   filter: false,width: 200},
                {label: '담당자 연락처',    field: 'contact_phone',   filter: false,width: 200},
                {label: '메모',    field: 'memo',   filter: false,width: '200px'},
                {label: '사업자등록증', field: 'bizregistration', filter: false,width: '150px',
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.genreEdit(data.id);
                        },
                        clicked2 : function(data) {
                            
                            //this.context.componentParent.genreDelete(data.id);
                        }

                    },
                    cellRenderer: 'btnDelete'
                },
                {label: '등록일',      field: 'created_at', width: '150px',formatFn: (data) => {
                    return this.fixDate(data, 'yyyy-MM-dd')
                }},
                {label: '업데이트일', field: 'updated_at', width: '150px',formatFn: (data) => {
                        return this.fixDate(data, 'yyyy-MM-dd')
                }}
            ],
            tableData:[
            ],       
            
            testMessage: "최고당!",

            
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        callList(){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('GET_AGGREGATOR', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result // 권리자 목록
                
                this.total = result.length // 총인원수 
                
                //페이지 수
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
            this.page.currentPage = 1  // 초기화
            this.callList()
        },
        viewDetail(event){
            this.$router.push('aggregator/detail/'+event.data.id)
        }
    }
}
</script>

<style scoped>

</style>
